import { lightBackgroundBlurAdmin } from '../figmaTokens/Admin';
export const blur = Object.assign({ 'blur-100': '4px', 'blur-200': '12px', 'blur-300': '24px', 'blur-400': '36px' }, lightBackgroundBlurAdmin);
